<template>
  <VDropdown
    placement="bottom-end"
    :aria-id="ariaId"
    @apply-show="isFocusLoopActive = true"
    @apply-hide="isFocusLoopActive = false"
    class="inline-flex"
    :disabled="isTooSmallScreenToDisplayDropdown"
  >
    <NavbarIconItem
      :has-red-indicator="!!notificationsStore.unseenCount"
      :indicator-value="notificationsStore.unseenCount"
      screen-reader-text="View notifications"
      @click="handleBellButtonClick"
    >
      <BellIcon class="size-6 xl:size-4.5" />
    </NavbarIconItem>
    <template #popper>
      <NotificationsDropdownPanel :is-focus-loop-active="isFocusLoopActive" />
    </template>
  </VDropdown>
</template>

<script setup>
import BellIcon from '~icons/lucide/bell'
import NavbarIconItem from '@/shared/components/navbar/NavbarIconItem.vue'
import NotificationsDropdownPanel from '@/modules/notifications/components/NotificationsDropdownPanel.vue'
import { computed, ref, useId } from 'vue'
import { useNotificationsStore } from '@/shared/stores/notifications.js'
import { router } from '@inertiajs/vue3'
import { useScreenWidth } from '@/shared/composables/useScreenWidth'

const { screenWidth, tailwindScreens } = useScreenWidth()
const notificationsStore = useNotificationsStore()

const ariaId = useId()
const isFocusLoopActive = ref(false)
const isTooSmallScreenToDisplayDropdown = computed(() => {
  return screenWidth < tailwindScreens.value.xs
})

const handleBellButtonClick = () => {
  // We don't want to show dropdown if screen is too small, that's why here is redirect and popover is disabled
  if (isTooSmallScreenToDisplayDropdown.value) {
    router.visit('/notifications')
  }
  if (notificationsStore.unseenCount === 0) return
  notificationsStore.markAllNotificationsAsSeen()
}
</script>
